/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_mobile_analytics_app_id": "97e679ab50124fa29e0c0d3de6a640b1",
    "aws_mobile_analytics_app_region": "us-west-2",
    "aws_appsync_graphqlEndpoint": "https://ilhawmou7fbappasf2lrbz7loi.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "us-west-2:cb1a1137-54cf-494c-a231-20aaae24a3d7",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_bAu1YSiWQ",
    "aws_user_pools_web_client_id": "hmidncs2dmp9lpr1qqmo6dfpf",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-west-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "screensightApplicationConfiguration-prod",
            "region": "us-west-2"
        }
    ],
    "aws_user_files_s3_bucket": "screensight-video-22aa7650145838-prod",
    "aws_user_files_s3_bucket_region": "us-west-2"
};


export default awsmobile;
